window._ = require('lodash')

if (window.$ === undefined) {
    window.Popper = require('popper.js').default
    window.$ = window.jQuery = require('jquery')
    require('bootstrap')
}

window.moment = require('moment')